module.exports = __webpack_public_path__ + "static/media/iconfont.43996c91.eot";